import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

export default function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        <br />
        <Link color="inherit" href="http://www.intentsolutions.com/contact" target="_blank">Contact Us</Link>
        <br />
          <Link color="inherit" href="http://www.intentsolutions.com/" target="_blank">www.intentsolutions.com</Link>
        <br />
        {'Copyright © '}
          Intent Solutions 
        {" " + new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }